import styled from "styled-components";

export const ResetPasswordWrapper = styled.div`
    height: calc(100vh - 271px);
    form{
        width: 600px;
    }
    .btn-reset{
        height: 40px;
    }
    
`
